module.exports = __webpack_public_path__ + "img/item_Character_fluid_01b.61a2ed2a.jpeg";